module.exports = __webpack_public_path__ + "static/media/chameau.10424d87.png";